<template>
  <div>
    <div
      class="button-wrapper"
      role="button"
      tabindex="0"
      @click="handleAppFeatureClick()"
    >
      <img
        src="@/assets/images/arrow-left.svg"
        alt="Return to previous"
      />
      <button
        class="return-back"
      >
        Back
      </button>
    </div>
  </div>
</template>

<script>
  import { useRouter } from 'vue-router'

  export default {
    name: 'MiBackBtn',
    props: {
      to: {
        type: String,
        required: false,
        default: '/'
      }
    },
    setup(props) {
      const router = useRouter()

      const handleAppFeatureClick = () => {
        router.push({ name: props.to })
      }

      return {
        router,
        handleAppFeatureClick
      }
    }
  }
</script>

<style lang="scss">
  .button-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }

  .return-back {
    color: $mi-anthracite-800;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    background: none;
    border: 0;
    padding: 0;
    cursor: pointer;
  }
</style>
